import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type { TbcrSliceState, TbcrResponse, TbcrBureauData } from './types';

const initialState: TbcrSliceState = {
  report: null,
  pollingStartedAt: null,
  needsVerification: false,
  canReRequest: false,
};

const creditReportTbcrSlice = createAppSlice({
  name: 'creditReportTbcr',
  initialState,
  reducers: {
    setTbcrReport(state, action: PayloadAction<TbcrResponse>) {
      state.report = action.payload;
    },
    setTbcrBureauData(state, action: PayloadAction<TbcrBureauData[]>) {
      if (state.report) {
        state.report.data = action.payload;
      }
    },
    clearTbcrReport(state) {
      state.report = null;
      state.pollingStartedAt = null;
      state.needsVerification = false;
      state.canReRequest = false;
    },
    setTbcrPollingStartedAt(state, action: PayloadAction<number>) {
      state.pollingStartedAt = action.payload;
    },
    setTbcrNeedsVerification(state, action: PayloadAction<boolean>) {
      state.needsVerification = action.payload;
    },
    setTbcrCanReRequest(state, action: PayloadAction<boolean>) {
      state.canReRequest = action.payload;
    },
  },
});

export const {
  setTbcrReport,
  setTbcrBureauData,
  clearTbcrReport,
  setTbcrPollingStartedAt,
  setTbcrNeedsVerification,
  setTbcrCanReRequest,
} = creditReportTbcrSlice.actions;

export default creditReportTbcrSlice.reducer;
